var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "testimonial" }, [
    _c("div", { staticClass: "mb-5 text-center" }, [
      _vm.testimonial.logo
        ? _c("img", {
            staticClass: "d-inline-block my-3 logo",
            attrs: { src: _vm.testimonial.logo }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("h5", { staticClass: "my-2" }, [
        _vm._v("\n      " + _vm._s(_vm.testimonial.name) + "\n    ")
      ]),
      _vm._v(" "),
      _c("small", { staticClass: "role" }, [
        _vm._v("\n      " + _vm._s(_vm.testimonial.role) + "\n    ")
      ])
    ]),
    _vm._v(" "),
    _c("p", [_vm._v("\n    " + _vm._s(_vm.testimonial.quote) + "\n  ")])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }